import { createSlice } from '@reduxjs/toolkit';
import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { environmentURLs } from '../../../components/common/CaptureEnvironment';

const initialState = {
  iscreateApiTermsConsentPending: false,
  createConsentSuccess: false,
  isgetConsentsPending: false,
  savedConsent: {},
  preloadApiTermsPending: true,
  preLoadedApiTerms: [],
  isGetUserDetailsPending: false,
  consentAndConnectionRecords: null,
  isCreateApiTermsConsentErrored: false,
};

export const createApiTermsConsent = createAsyncThunk(
  'createApiTermsConsent',
  async ({ consentPayload, solutionId, listingVersion, token }) => {
    let response = await axios.post(
      `${environmentURLs.REACT_APP_MP_DP_METADATA_URL}/solutions/${solutionId}/${listingVersion}/consents`,
      {
        consent: consentPayload
      },
      {
        headers: {
          Authorization: `Bearer ${token}`
        }
      }
    );
    return response;
  }
);

export const preloadApiTerms = createAsyncThunk(
  'preloadApiTerms',
  async solutionConnectionDetails => {
    let terms = {};
    let promises = [];
    solutionConnectionDetails.forEach(provider => {
      promises.push(
        axios({
          method: 'get',
          url: provider.addendumDoc,
          responseType: 'blob'
        })
          .then(res => {
            const reader = new FileReader();
            reader.onloadend = () => {
              let temp = {};
              temp[provider.id] = reader.result;
              terms = { ...terms, ...temp };
            };
            reader.readAsDataURL(res && res.data);
          })
          .catch(e => {})
      );
    });
    Promise.all(promises).then(() => {
      return terms;
    });
  }
);

export const getConsents = createAsyncThunk(
  'getConsents',
  async ({ solutionId, entityId, token, consentType, api, apiProviderId }) => {
    let response = await axios.get(
      `${environmentURLs.REACT_APP_MP_DP_METADATA_URL}/solutions/${solutionId}/consents?entityId=${entityId}&consentType=${consentType}&api=${api}&apiProviderId=${apiProviderId}`,
      {
        headers: {
          Authorization: `Bearer ${token}`
        }
      }
    );
    return {
      entityId,
      response
    };
  }
);

export const getUserDetails = createAsyncThunk(
  'getUserDetails',
  async ({ loggedInUserEmail,userFirstName,userLastName,token}) => {
    let email =loggedInUserEmail;
    let response = await axios.get(
      `${environmentURLs.REACT_APP_MP_DP_METADATA_URL}/user/role?email=${email}&firstName=${userFirstName}&lastName=${userLastName}`,
      {
        headers: {
          Authorization: `Bearer ${token}`
        }
      }
    );
    return response;
  }
);

export const consentApiTerms = createAsyncThunk(
  'consentApiTerms',
  async ({payload, token}) => {
    let response = await axios.post(
      `${environmentURLs.REACT_APP_MP_DP_METADATA_URL}/bulk-consents`,
      payload,
      {
        headers: {
          Authorization: `Bearer ${token}`
        }
      }
    );
    return response;
  }
)

export const apiTermsSlice = createSlice({
  name: 'apiTermsSlice',
  initialState,
  reducers: {
    savePreloadedTerms: (state, action) => {
      state.preLoadedAppTerms = action.payload;
    },
    updateConsentSuccess: (state)=>{
      state.createConsentSuccess = false
    },
    clearState: state => {
      state.consentAndConnectionRecords = null
    },
    resetErrors: state => {
      state.isCreateApiTermsConsentErrored = false;
    }
  },
  extraReducers: {
    [consentApiTerms.fulfilled]: (state, action) => {
     const {consentItems, dealerPortalRecords} = action.payload.data;
     if(state.consentAndConnectionRecords && state.consentAndConnectionRecords.consentItems && state.consentAndConnectionRecords.dealerPortalRecords) {
        state.consentAndConnectionRecords.consentItems.push(...consentItems);
        state.consentAndConnectionRecords.dealerPortalRecords.push(...dealerPortalRecords)
     } else {
        state.consentAndConnectionRecords = action.payload.data;
     }

      state.iscreateApiTermsConsentPending = false;
      state.isCreateApiTermsConsentErrored = false;
    },
    [consentApiTerms.pending]: state => {
      state.iscreateApiTermsConsentPending = true;
      state.isCreateApiTermsConsentErrored = false;
    },
    [consentApiTerms.rejected]: state => {
      state.iscreateApiTermsConsentPending = false;
      state.isCreateApiTermsConsentErrored = true;
    },
    [createApiTermsConsent.fulfilled]: (state, action) => {
      state.iscreateApiTermsConsentPending = false;
      state.createConsentSuccess = true;
    },
    [createApiTermsConsent.pending]: state => {
      state.iscreateApiTermsConsentPending = true;
    },
    [createApiTermsConsent.rejected]: state => {
      state.iscreateApiTermsConsentPending = false;
    },
    [getConsents.fulfilled]: (state, action) => {
      let consent =
        action.payload &&
        action.payload.response &&
        action.payload.response.data[0];
      let entityId = action.payload && action.payload.entityId;
      state.savedConsent = {
        [entityId]: consent
      };
      state.isgetConsentsPending = false;
    },
    [getConsents.pending]: state => {
      state.isgetConsentsPending = true;
    },
    [getConsents.rejected]: state => {
      state.isgetConsentsPending = false;
    },
    [getUserDetails.fulfilled]: (state, action) => {
      state.isGetUserDetailsPending = false;
    },
    [getUserDetails.pending]: state => {
      state.isGetUserDetailsPending = true;
    },
    [getUserDetails.rejected]: state => {
      state.isGetUserDetailsPending = false;
    },
    [preloadApiTerms.fulfilled]: (state, action) => {
      state.preLoadedApiTerms = action.payload;
      state.preloadApiTermsPending = false;
    },
    [preloadApiTerms.pending]: state => {
      state.preloadApiTermsPending = true;
    },
    [preloadApiTerms.rejected]: state => {
      state.preloadApiTermsPending = false;
      state.preLoadedApiTerms = [];
    },
  }
});

export const { savePreloadedTerms,updateConsentSuccess, clearState, resetErrors } = apiTermsSlice.actions;

export default apiTermsSlice.reducer;